import React from "react";
import PropTypes from "prop-types";
import { ArrowLeft, ArrowRight } from "lucide-react";

import { UIAvatar } from "../../ui";
import { clx } from "../../../utils/Helpers";

import "./ClientCompanySelectionCard.scss";

const ClientCompanySelectionCard = ({
  company,
  partnerLabel,
  selectAriaLabel,
  lang,
  onSelect,
  className,
}) => {
  const ArrowIcon = lang === "ar" ? ArrowLeft : ArrowRight;
  const ariaLabel = selectAriaLabel.replace("{company}", company.name);

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onSelect(company);
    }
  };

  return (
    <article
      role="button"
      tabIndex={0}
      className={clx("client-company-selection-card", className)}
      data-company-id={company.id}
      aria-label={ariaLabel}
      onClick={() => onSelect(company)}
      onKeyDown={handleKeyDown}
    >
      <UIAvatar
        className="client-company-selection-card__logo"
        name={company.name}
        src={company.image_url}
        size="lg"
        alt=""
      />

      <div className="client-company-selection-card__body">
        <p className="client-company-selection-card__eyebrow">{partnerLabel}</p>
        <h3 className="client-company-selection-card__name">{company.name}</h3>
      </div>

      <span className="client-company-selection-card__action" aria-hidden>
        <ArrowIcon size={24} />
      </span>
    </article>
  );
};

ClientCompanySelectionCard.propTypes = {
  company: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    name: PropTypes.string.isRequired,
    image_url: PropTypes.string,
  }).isRequired,
  partnerLabel: PropTypes.string.isRequired,
  selectAriaLabel: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  className: PropTypes.string,
};

ClientCompanySelectionCard.defaultProps = {
  className: "",
};

export default ClientCompanySelectionCard;
